import { persistStateTypes } from 'a/reducers/persistStateReducer';
import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';

const savedDataReducer = (state = {}, { type, gameId, payload, stateData }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case persistStateTypes.REQUESTRESPONSE_GAMESTATE: {
      const { GameData: savedData } = stateData[GAME_ID];

      if (savedData !== null && savedData !== undefined) {
        const { gameDetails, ...savedProgress } = savedData; // Exclude gameDetails from saved progress
        return {
          ...state,
          ...savedProgress,
        };
      }
      return state;
    }

    case persistStateTypes.REQUESTERROR_GAMESTATE: {
      return state;
    }

    case REDUX_ACTIONS.ADD_LEVEL_TO_LOCALLY_SAVED_DATA: {
      return {
        ...state,
        ...payload,
      };
    }

    case REDUX_ACTIONS.CLEAR_LOCALLY_SAVED_LEVEL: {
      const newSavedData = { ...state };
      const { isAssignmentLinkMode, assignmentId, levelIndex } = payload;

      if (!isAssignmentLinkMode) {
        delete newSavedData[levelIndex];
      } else {
        // Delete entire assignment when level completes
        delete newSavedData[assignmentId];
      }

      return newSavedData;
    }

    default:
      return state;
  }
};

export default savedDataReducer;
